export const validateUrl = (input) => {
    try {
        new URL(input);
        return true;
    } catch (e) {
        return false;
    }
};

export const validateDate = (input) => {
    const startDate = new Date(input);
    return !(Number.isNaN(startDate));
};

export const validateOutflow = (input) => !Number.isNaN(input);
